import React from 'react';
import Pantalla3Lic from '../Pantalla3Lic/Pantalla3Lic';
import Footer from '../../Footer/Footer';

function PantallaBase3Lic() {

    return (
        <>
            <div className='initBack_P2 animate__animated animate__fadeIn'>
                <div className='containerRender'>
                    <Pantalla3Lic />
                </div>
                <Footer />
            </div>
        </>
    )
}

export default PantallaBase3Lic
